<template>
  <b-row class="justify-content-center">
      <div class="bg-white not-found" v-html="svg.notFound"></div>
  </b-row>
</template>

<script>

import svg from '../../_svg.js'

export default {
  name: 'Page404',
  data () {
    return {
      svg: svg
    }
  }
}
</script>
<style>
  .not-found {
    padding: 2rem 4rem;
    border-radius: 1rem;
    max-height: 50vh;
    width: 60vw;
    margin-top: 5rem;
  }

  @media (max-width: 440px){
    .not-found {
      padding: 0.5rem 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pages/Page404.vue